import { BaseClientType, ClientStepProps } from '../../types';
import { JSX } from 'react';
import FNAs from '../../../fna/FNAs';

/**
 * Related FNAs for natural person or legal entity
 */
const RelatedFnaStep = <T extends BaseClientType>({ client }: ClientStepProps<T>): JSX.Element => {
  return <FNAs editable roleplayerId={client.roleplayerID} />;
};

export default RelatedFnaStep;
